import { ISupervisoryDashboard, SupervisoryDashboardInfo, SupervisoryDashboardQuery } from './supervisory-dashboard.model';
import HttpClient from "../../common/http/httpClient";

const supervisoryDashboard = (): ISupervisoryDashboard => {
    return {
        getSupervisoryDashboard: (queryParams: SupervisoryDashboardQuery): HttpPromise<SupervisoryDashboardInfo> => {
            return HttpClient
                .post<SupervisoryDashboardInfo>(`${process.env.REACT_APP_API_BASE_URL}/api/supervisory-dashboard/v2`, { data: queryParams })
                .then((res) => {
                    // If response contains a data property, return that
                    if (res.data && typeof res.data === 'object' && res.data.header) {
                        return res.data;
                    }
                    
                    // Otherwise return the response itself
                    return res;
                });
        }
    };
}
    
export default supervisoryDashboard();